import { AccommodationGuestDetails } from '@/renderer/types/accommodation';
import { formatGuestPreviewCurrency } from '@lib/utils';
import React from 'react';
import { GuestPreviewSection } from './GuestPreviewSection';

interface GuestPreviewSalesProfileProps {
  details: AccommodationGuestDetails;
}

export const GuestPreviewSalesProfile: React.FC<
  GuestPreviewSalesProfileProps
> = ({ details }) => {
  return (
    <GuestPreviewSection title="Sales Module Profile">
      <div className="space-y-3 text-sm text-gray-700">
        <p>
          <span className="font-semibold text-gray-950">Top Items:</span>{' '}
          {details.top_items.length > 0
            ? details.top_items.map((item) => item.name).join(', ')
            : 'No sales history yet'}
        </p>
        <p>
          <span className="font-semibold text-gray-950">Open Tabs:</span>{' '}
          {details.open_tabs_count > 0 ? (
            <span className="font-semibold text-red-600">
              {formatGuestPreviewCurrency(
                details.outstanding_credit_balance,
                details.currency,
              )}{' '}
              ({details.open_tabs_count} open)
            </span>
          ) : (
            'None'
          )}
        </p>
        <p>
          <span className="font-semibold text-gray-950">Payment Method:</span>{' '}
          {details.preferred_payment_method || '—'}
        </p>
        <p>
          <span className="font-semibold text-gray-950">Stay Pattern:</span>{' '}
          {details.common_stay_pattern}
        </p>
        <p>
          <span className="font-semibold text-gray-950">Lead Time:</span>{' '}
          {details.lead_time_label}
        </p>
        <p>
          <span className="font-semibold text-gray-950">Preferred Room:</span>{' '}
          {details.preferred_room || '—'}
        </p>
      </div>
    </GuestPreviewSection>
  );
};
